export default __webpack_public_path__ + "a4162c4.png";